// src/index.tsx
import * as React3 from "react";
import { getCompatContextProvider } from "react-querybuilder";

// src/BootstrapNotToggle.tsx
import * as React from "react";
import { useId } from "react";
var BootstrapNotToggle = ({
  className,
  handleOnChange,
  title,
  label,
  checked,
  disabled
}) => {
  const id = useId();
  return /* @__PURE__ */ React.createElement("div", { className: `form-check-inline form-switch ${className}` }, /* @__PURE__ */ React.createElement(
    "input",
    {
      id,
      className: "form-check-input",
      type: "checkbox",
      onChange: (e) => handleOnChange(e.target.checked),
      checked: !!checked,
      disabled
    }
  ), /* @__PURE__ */ React.createElement("label", { title, htmlFor: id, className: "form-check-label" }, label));
};

// src/BootstrapValueEditor.tsx
import * as React2 from "react";
import {
  getFirstOption,
  standardClassnames,
  useValueEditor,
  ValueEditor,
  ValueSelector
} from "react-querybuilder";
var BootstrapValueEditor = (props) => {
  const { valueAsArray, multiValueHandler } = useValueEditor({
    handleOnChange: props.handleOnChange,
    inputType: props.inputType,
    operator: props.operator,
    value: props.value,
    type: props.type,
    listsAsArrays: props.listsAsArrays,
    parseNumbers: props.parseNumbers,
    values: props.values
  });
  const { selectorComponent: SelectorComponent = ValueSelector } = props;
  if (props.operator === "null" || props.operator === "notNull") {
    return null;
  }
  const placeHolderText = props.fieldData?.placeholder ?? "";
  if ((props.operator === "between" || props.operator === "notBetween") && (props.type === "select" || props.type === "text")) {
    const editors = ["from", "to"].map((key, i) => {
      if (props.type === "text") {
        return /* @__PURE__ */ React2.createElement(
          "input",
          {
            key,
            type: props.inputType || "text",
            placeholder: placeHolderText,
            value: valueAsArray[i] ?? "",
            className: `${standardClassnames.valueListItem} form-control form-control-sm`,
            disabled: props.disabled,
            onChange: (e) => multiValueHandler(e.target.value, i)
          }
        );
      }
      return /* @__PURE__ */ React2.createElement(
        SelectorComponent,
        {
          ...props,
          key,
          className: `${standardClassnames.valueListItem} form-select form-select-sm`,
          handleOnChange: (v) => multiValueHandler(v, i),
          disabled: props.disabled,
          value: valueAsArray[i] ?? getFirstOption(props.values),
          options: props.values ?? [],
          listsAsArrays: props.listsAsArrays
        }
      );
    });
    return /* @__PURE__ */ React2.createElement("span", { "data-testid": props.testID, className: standardClassnames.value, title: props.title }, editors[0], props.separator, editors[1]);
  }
  switch (props.type) {
    case "select":
    case "multiselect":
      return /* @__PURE__ */ React2.createElement(
        ValueEditor,
        {
          skipHook: true,
          ...props,
          className: `${props.className} form-select form-select-sm`
        }
      );
    case "switch":
      return /* @__PURE__ */ React2.createElement("span", { className: `custom-control custom-switch ${props.className}` }, /* @__PURE__ */ React2.createElement(
        "input",
        {
          type: "checkbox",
          className: "form-check-input custom-control-input",
          title: props.title,
          disabled: props.disabled,
          onChange: (e) => props.handleOnChange(e.target.checked),
          checked: !!props.value
        }
      ));
    case "checkbox":
      return /* @__PURE__ */ React2.createElement(ValueEditor, { skipHook: true, ...props, className: `form-check-input ${props.className}` });
    case "radio":
      return /* @__PURE__ */ React2.createElement("span", { title: props.title, className: standardClassnames.value }, props.values?.map((v) => /* @__PURE__ */ React2.createElement("div", { key: v.name, className: "form-check form-check-inline" }, /* @__PURE__ */ React2.createElement(
        "input",
        {
          className: "form-check-input",
          type: "radio",
          id: v.name,
          value: v.name,
          checked: props.value === v.name,
          disabled: props.disabled,
          onChange: (e) => props.handleOnChange(e.target.value)
        }
      ), /* @__PURE__ */ React2.createElement("label", { className: "form-check-label", htmlFor: v.name }, v.label))));
  }
  return /* @__PURE__ */ React2.createElement(ValueEditor, { skipHook: true, ...props });
};

// src/index.tsx
var bootstrapControlElements = {
  notToggle: BootstrapNotToggle,
  valueEditor: BootstrapValueEditor
};
var bootstrapControlClassnames = {
  actionElement: "btn btn-sm",
  addGroup: "btn-secondary",
  addRule: "btn-primary",
  cloneGroup: "btn-secondary",
  cloneRule: "btn-secondary",
  lockGroup: "btn-secondary",
  lockRule: "btn-secondary",
  removeGroup: "btn-danger",
  removeRule: "btn-danger",
  value: "form-control form-control-sm",
  valueSelector: "form-select form-select-sm"
};
var bootstrapTranslations = {
  removeGroup: { label: /* @__PURE__ */ React3.createElement("i", { className: "bi bi-x" }) },
  removeRule: { label: /* @__PURE__ */ React3.createElement("i", { className: "bi bi-x" }) },
  cloneRule: { label: /* @__PURE__ */ React3.createElement("i", { className: "bi bi-copy" }) },
  cloneRuleGroup: { label: /* @__PURE__ */ React3.createElement("i", { className: "bi bi-copy" }) },
  dragHandle: { label: /* @__PURE__ */ React3.createElement("i", { className: "bi bi-grip-vertical" }) },
  lockGroup: { label: /* @__PURE__ */ React3.createElement("i", { className: "bi bi-unlock" }) },
  lockRule: { label: /* @__PURE__ */ React3.createElement("i", { className: "bi bi-unlock" }) },
  lockGroupDisabled: { label: /* @__PURE__ */ React3.createElement("i", { className: "bi bi-lock" }) },
  lockRuleDisabled: { label: /* @__PURE__ */ React3.createElement("i", { className: "bi bi-lock" }) },
  shiftActionUp: { label: /* @__PURE__ */ React3.createElement("i", { className: "bi bi-chevron-compact-up" }) },
  shiftActionDown: { label: /* @__PURE__ */ React3.createElement("i", { className: "bi bi-chevron-compact-down" }) }
};
var QueryBuilderBootstrap = getCompatContextProvider({
  controlClassnames: bootstrapControlClassnames,
  controlElements: bootstrapControlElements,
  translations: bootstrapTranslations
});
export {
  BootstrapNotToggle,
  BootstrapValueEditor,
  QueryBuilderBootstrap,
  bootstrapControlClassnames,
  bootstrapControlElements,
  bootstrapTranslations
};
//# sourceMappingURL=react-querybuilder_bootstrap.mjs.map